// src/pages/PoliticaCancelamento/PoliticaCancelamento.jsx

import React from 'react';
import '../LegalPages.css'; // Reutilizando os estilos das páginas legais
import { FaWhatsapp, FaPhone } from 'react-icons/fa';

const PoliticaCancelamento = () => {
  return (
    <div className="legal-page-container">
      <h1>Política de Cancelamento e Reservas</h1>
      <p><strong>Última atualização:</strong> 02 de Outubro de 2025</p>

      <p>
        No Hotel Alzira Imperial, nosso objetivo é oferecer uma experiência excepcional desde o momento da reserva até o final da sua estadia. Nossas políticas foram criadas para serem justas e claras. Por favor, entre em contato pelos nossos canais de atendimento antes de confirmar sua reserva.
      </p>


      <p className="company-info">
        <strong>ALZIRA IMPERIAL HOTEL</strong><br />
        CNPJ: 24.618.487/0001-39 <br />
        Endereço: Av Dom Pedro II, 593 - Centro, São Lourenço-MG<br />

        <a href="tel:+553533321144" className="whatsapp-link" target="_blank" rel="noopener noreferrer">
          <FaPhone />
          <span>(35) 3332-1144</span>

        </a>
        <br />
        <a href="https://wa.me/+5535988171649" className="whatsapp-link" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp />
          <span>Whatsapp</span>
        </a>
      </p>
    </div>
  );
};

export default PoliticaCancelamento;